import type {
    IChartData,
    IMetaData,
    IAxisMetaData,
    IDataPoint,
} from "app/pages/industry-analysis/players/table/bubble-chart/types";

export const getMetaData = (chartData: IChartData): IMetaData => {
    const xAxis = getAxisMetaData(chartData, "x");
    const yAxis = getAxisMetaData(chartData, "y");
    const zAxis = getAxisMetaData(chartData, "z");
    const metaData = { xAxis, yAxis, zAxis };
    return metaData;
};
const getAxisMetaData = (chartData: IChartData, axis: keyof IDataPoint): IAxisMetaData => {
    const axisValues = chartData.flatMap((dataItem) => dataItem.data.flatMap((data) => data[axis])).filter(Boolean);
    const min = Math.min(...axisValues);
    const max = Math.max(...axisValues);
    const average = axisValues.reduce((average, value) => average + value / axisValues.length, 0);
    const range = { from: min, to: max };
    return { range, average };
};
